import { apiUrl } from '../../environments/environments'
import axios from 'axios'
import Constants from '../constants'

export function GetPrices(productId, callback) {
    const token = localStorage.getItem('msal.idtoken')

    axios
        .get(`${apiUrl}/Prices?productId=${productId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
        .then((response) => {
            if (response.status === 200) {
                callback(response.data.result || [])
            }
        })
        .catch((error) => {
            console.error('Error fetching prices:', error)
            callback([])
        })
}

function UpdatePrice(Price) {
    fetch(apiUrl + '/Prices/' + Price.id, {
        method: 'PUT',
        body: JSON.stringify(Price),
        headers: Constants.ApiHeader(),
    }).then((res) => res.json())
}

function UpdatePricesList(name, prices) {
    return fetch(`${apiUrl}/Products/${name}/Prices`, {
        method: 'PUT',
        body: JSON.stringify(prices),
        headers: Constants.ApiHeader(),
    })
        .then((res) => {
            return res.json()
        })
        .then((res) => res.result)
        .catch((error) => {
            console.error('Error fetching product options:', error)
        })
}

function UpdatePrices(prices) {
    return fetch(`${apiUrl}/Prices`, {
        method: 'PUT',
        body: JSON.stringify(prices),
        headers: Constants.ApiHeader(),
    })
        .then((res) => {
            return res.json()
        })
        .then((res) => res.result)
        .catch((error) => {
            console.error('Error saving the prices:', error)
        })
}

export { UpdatePrice, UpdatePricesList, UpdatePrices }
